var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentsLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 67,
    viewBox: "0 0 300 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M116.333 8.65087C39.8327 -10.2933 -24.1672 8.64823 -8.66726 16.6517V95.6547H296.333C325.999 69.3203 357.533 43.7488 286.333 54.1512C197.333 67.1542 167.332 21.2802 116.333 8.65087Z",
    fill: "url(#paint0_linear_33617_93544)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33617_93544",
    x1: 163.489,
    y1: 95.6487,
    x2: 163.489,
    y2: -8.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E94FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C4BB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentsLeftBg);
export default __webpack_public_path__ + "static/media/assessments-left-bg.4a688b2a8fc9610f76250c21cac69ff6.svg";
export { ForwardRef as ReactComponent };